import { useContext, useState } from "react";
import { Button, Input } from "../../../ui";
import { Context } from "../../../../context/Context";
import { useBillingAdminText } from "../billingAdminI18n";

// Adds a not-yet-covered branch to the restaurant's existing current
// subscription. Unlike ExtendCoverageModal (which only ever moves an
// existing endDate forward), a brand-new branchCoverage entry needs both a
// startDate and an endDate.
const AddBranchModal = ({ branch, onCancel, onConfirm }) => {
  const { lang } = useContext(Context);
  const text = useBillingAdminText(lang);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const confirm = async () => {
    setError("");
    if (!startDate || !endDate) {
      setError(text.subscriptions.selectStartAndEndDate);
      return;
    }
    if (startDate > endDate) {
      setError(text.subscriptions.endDateBeforeStartDate);
      return;
    }
    setSaving(true);
    try {
      await onConfirm({ startDate, endDate });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="billing-modal-backdrop">
      <div className="billing-modal">
        <h3>{text.subscriptions.addBranchTitle}</h3>
        <p>{text.subscriptions.addBranchDescription}</p>
        {error && <div className="billing-error">{error}</div>}
        <div className="billing-branch-list">
          <div className="billing-branch-option billing-sub-branch-row">
            <span>{branch.name}</span>
          </div>
        </div>
        <div className="billing-form-grid">
          <Input
            type="date"
            label={text.subscriptions.startDate}
            value={startDate}
            onChange={(event) => setStartDate(event.target.value)}
          />
          <Input
            type="date"
            label={text.subscriptions.endDate}
            min={startDate || undefined}
            value={endDate}
            onChange={(event) => setEndDate(event.target.value)}
          />
        </div>
        <div className="billing-modal-actions">
          <Button appearance="filled" loading={saving} onClick={confirm}>
            {text.subscriptions.confirmAddBranch}
          </Button>
          <Button appearance="ghost" onClick={onCancel}>
            {text.common.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddBranchModal;
